import styled from '@emotion/styled';

export const Section = styled.section(({ theme }) => ({
  border: `1px solid ${theme.color.divider}`,
  borderRadius: 8,
  padding: 16,
}));
